<script>
export default {
  name: 'WhatsAppWindowTimer',
  props: {
    expiresAt: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      now: Math.floor(Date.now() / 1000),
      timer: null,
    };
  },
  computed: {
    secondsRemaining() {
      if (!this.expiresAt) return 0;
      return Math.max(0, this.expiresAt - this.now);
    },
    hoursRemaining() {
      return Math.floor(this.secondsRemaining / 3600);
    },
    minutesRemaining() {
      return Math.floor((this.secondsRemaining % 3600) / 60);
    },
    timeLabel() {
      if (this.secondsRemaining <= 0) return null;
      if (this.hoursRemaining > 0) {
        return this.$t('CONVERSATION.WHATSAPP_WINDOW_TIMER.HOURS_MINUTES', {
          hours: this.hoursRemaining,
          minutes: this.minutesRemaining,
        });
      }
      return this.$t('CONVERSATION.WHATSAPP_WINDOW_TIMER.MINUTES_ONLY', {
        minutes: this.minutesRemaining,
      });
    },
    colorScheme() {
      if (this.hoursRemaining >= 4) return 'green';
      if (this.hoursRemaining >= 1) return 'yellow';
      return 'red';
    },
    bannerClasses() {
      const base =
        'flex items-center gap-2 px-3 py-2 mx-2 mt-2 rounded-lg text-sm font-medium';
      if (this.colorScheme === 'green')
        return `${base} bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-300`;
      if (this.colorScheme === 'yellow')
        return `${base} bg-yellow-50 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300`;
      return `${base} bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300`;
    },
    iconName() {
      if (this.colorScheme === 'green') return 'i-lucide-clock';
      if (this.colorScheme === 'yellow') return 'i-lucide-clock-alert';
      return 'i-lucide-alarm-clock';
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = Math.floor(Date.now() / 1000);
    }, 60000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<template>
  <div v-if="timeLabel" :class="bannerClasses">
    <span class="i-lucide-clock h-4 w-4 flex-shrink-0" />
    <span>
      {{ $t('CONVERSATION.WHATSAPP_WINDOW_TIMER.LABEL') }}
      <strong>{{ timeLabel }}</strong>
    </span>
  </div>
</template>
